var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconIllustrationArchive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 50.002V64.67c0 .736.448 1.333 1 1.333h58c.552 0 1-.597 1-1.333V50.002H10zm59 18H11c-1.654 0-3-1.346-3-3v-16a1 1 0 011-1h62a1 1 0 011 1v16c0 1.654-1.346 3-3 3z",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 48.002h60v-16H10v16zm-1 2a1 1 0 01-1-1v-18a1 1 0 011-1h62a1 1 0 011 1v18a1 1 0 01-1 1H9z",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.388 30.002h59.297L65.24 14H15.72l-5.332 16.002zm60.612 2H9a.998.998 0 01-.948-1.316l5.773-17.319A1.994 1.994 0 0115.72 12h49.52c.894 0 1.686.602 1.926 1.464l4.797 17.27A1 1 0 0171 32.002zM32 57.003v1a1 1 0 001 1h14a1 1 0 001-1v-1H32zm15 4H33c-1.654 0-3-1.346-3-3v-2a1 1 0 011-1h18a1 1 0 011 1v2c0 1.654-1.346 3-3 3zM26.001 59.002h2v-2h-2zM52.001 59.002h2v-2h-2zM32 38.992v1a1 1 0 001 1h14a1 1 0 001-1v-1H32zm15 4H33c-1.654 0-3-1.346-3-3v-2a1 1 0 011-1h18a1 1 0 011 1v2c0 1.654-1.346 3-3 3zM26.001 40.991h2v-2h-2zM52.001 40.991h2v-2h-2z",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E97025",
    d: "M62.002 20.997h-2v-2.994l-39.998-.006v3h-2v-5h43.998M64.002 27.997h-2v-2.994l-43.998-.006v3h-2v-5h47.998",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h80v80H0z"
  }))));
}

export default SvgIconIllustrationArchive;